import React, { createContext, useReducer } from "react";
import { initialState, mccFollowUpReducer } from "../state/mccFollowUpReducer";

export const FollowUpModalDispatchContext = createContext();
export const FollowUpModalStateContext = createContext();

const FollowUpModalProvider = ({ children }) => {
  const [state, dispatch] = useReducer(mccFollowUpReducer, initialState);

  return (
    <FollowUpModalDispatchContext.Provider value={dispatch}>
      <FollowUpModalStateContext.Provider value={state}>
        {React.Children.map(children, (child) => React.cloneElement(child))}
      </FollowUpModalStateContext.Provider>
    </FollowUpModalDispatchContext.Provider>
  );
};

export default FollowUpModalProvider;
